export default __webpack_public_path__ + "static/media/lampshade-new-crop.94ee9a5d.jpg";